
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ComponentVariantModel } from '@models/component-variant';
import { ModelGroupModel } from '@models/model-group';
import { TranslatePipe } from '@ngx-translate/core';
import { BrandModeService } from '@services/brandmode.service';
import { LanguageService } from '@services/language.service';
import { ComponentCodeConstants } from '@shared/component-constants';
import { ProductlineConstants } from '@shared/productline-constants';

@Component({
    selector: 'precious-metal-info',
    templateUrl: './precious-metal-info.component.html',
    styleUrls: ['./precious-metal-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe]
})

export class PreciousMetalInfoComponent implements OnInit {

	@Input() selectedVariant: ComponentVariantModel;
	@Input() modelGroup: ModelGroupModel;

	public showInfoLink: boolean = true;
	public infoLink: string;
	constructor(private brandModeService: BrandModeService, private languageService: LanguageService) { }

	ngOnInit(): void {
		this.showInfoLink = this.brandModeService.isPrecious;
		if (this.selectedVariant?.Component.Code === ComponentCodeConstants.Front && this.modelGroup?.ProductLineCode === ProductlineConstants.HORN) {
			this.showInfoLink = false;
		}
		switch (this.languageService.currentLanguage) {
			case 'de':
				this.infoLink = "https://lindberg.com/de/kollektionen/precious";
				break;
			case 'fr':
				this.infoLink = "https://lindberg.com/fr/collections/precious";
				break;
			case 'es':
				this.infoLink = "https://lindberg.com/es/colecciones/precious";
				break;
			case 'it':
				this.infoLink = "https://lindberg.com/it/collezioni/precious";
				break;
			case 'ko':
				this.infoLink = "https://lindberg.com/ko/%EC%BB%AC%EB%A0%89%EC%85%98%EB%93%A4/precious";
				break;
			case 'ja':
				this.infoLink = "https://lindberg.com/ja/%E3%82%B3%E3%83%AC%E3%82%AF%E3%82%B7%E3%83%A7%E3%83%B3/precious";
				break;
			case 'zh':
				this.infoLink = "https://lindberg.com/zh/%E4%BA%A7%E5%93%81%E7%B3%BB%E5%88%97/%E8%B4%B5%E9%87%91%E5%B1%9E%E9%95%9C%E6%9E%B6";
				break;
			default:
				this.infoLink = "https://lindberg.com/en/collections/precious";
				break;
		}
	}

}
